export const EmailStatuses = {
    IDLE: 'idle',
    PENDING: 'pending'
}
Object.freeze(EmailStatuses)

export const contact = {
    namespaced: true,
    state: {
        status: EmailStatuses.IDLE
    },
    mutations: {
        SET_STATUS(state, status) {
            state.status = status
        }
    },
    actions: {
        async sendEmail({ commit }, { area, companyName, counties, message, name, surname, phone }) {
            const emailData = {
                first_name: name,
                last_name: surname,
                company_name: companyName,
                hectares: area,
                message,
                counties,
                phone
            }

            commit('SET_STATUS', EmailStatuses.PENDING)

            try{
                const response = await this.$api.post('api/contact-form', emailData)
                return response
            } finally{
                commit('SET_STATUS', EmailStatuses.IDLE)
            }
        }
    },
    getters: {
        getStatus(state) {
            return state.status
        }
    }
}
